'use strict';

angular.module('formonlineApp')
	.controller('SubmenuController', function ($scope, $location, $state, Auth, Principal, submenuSettings) {
		$scope.isAuthenticated = Principal.isAuthenticated;
		$scope.$state = $state;

		$scope.items = null;

		this.init = function (title, breadcrumbItems, menuItems) {
			$scope.title = title;
			$scope.breadcrumbItems = breadcrumbItems;
			$scope.menuItems = menuItems;
		};

		submenuSettings.setCallback(this.init);

	});
